import type { LightInvoiceUsageLineItem } from '@weft/api-definition';
import { getTierUsagePrice } from '@weft/services';
import type { TiersUsageMap } from '@weft/types';
import type { ItemOf } from '@weft/utils';
import { isNotNullOrUndefined } from '@weft/utils';

export function getPerUnitProductVariantPrice(productVariant: ItemOf<LightInvoiceUsageLineItem['perUnitProductVariants']>, tiersUsageMap: TiersUsageMap) {
  const initialVariantPrice = productVariant.pricing.priceConfiguration.price;
  const perUnitVariantTierUsageMap = tiersUsageMap[productVariant.id];
  const perUnitVariantPrice = isNotNullOrUndefined(perUnitVariantTierUsageMap[0]) 
    ? getTierUsagePrice(perUnitVariantTierUsageMap[0], initialVariantPrice)
    : initialVariantPrice; 

  return perUnitVariantPrice;
}